<script>
  import Main from "./Main.svelte";
  import Footer from "./Footer.svelte";
  import { onMount } from "svelte";

  let red_theme;
  let green_theme;
  let purple_theme;

  const changeCustomCss = (primary, light, dark) => {
    document.documentElement.style.setProperty("--primary-color", primary);
    document.documentElement.style.setProperty("--primary-color-light", light);
    document.documentElement.style.setProperty("--primary-color-dark", dark);
  };

  onMount(() => {
    red_theme.addEventListener("click", () => {
      changeCustomCss("#e74c3c", "#e67e22", "#c0392b");
    });
    green_theme.addEventListener("click", () => {
      changeCustomCss("#1abc9c", "#2ecc71", "#16a085");
    });
    purple_theme.addEventListener("click", () => {
      changeCustomCss("#474787", "#706fd3", "#40407a");
    });
  });
</script>

<style>
  .container {
    width: 100%;
    max-width: 1200px;
    background: #fdfdfd;
    height: 80vh;
    margin-bottom: 5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%);
    border-radius: 3px;
    box-shadow: 0 3rem 4rem rgba(0, 0, 0, 0.4);
  }

  .theme {
    position: fixed;
    top: 50%;
    left: 0;
    background: #fdfdfd;
    width: 5rem;
    height: 15rem;
    transform: translateY(-80%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .theme a {
    width: 3rem;
    height: 3rem;
    text-decoration: none;
    font-size: 1.6rem;
    margin: 0.5rem 0;
    border-radius: 3px;
    color: var(--white);
    text-align: center;
    display: block;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .theme-red {
    background: #e74c3c;
  }
  .theme-green {
    background: #1abc9c;
  }
  .theme-purple {
    background: #474787;
  }

  @media only screen and (max-width: 950px) {
    .container {
      height: 93vh;
      top: 0;
      left: 0;
      transform: none;
    }

    .theme {
      top: 50%;
      left: 0;
      z-index: 30;
      width: 3rem;
      height: 15rem;
      transform: translateY(-80%);
      box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.4);
    }

    .theme a {
      width: 2rem;
      height: 3rem;
    }
  }
</style>

<div class="theme">
  <a bind:this={red_theme} class="theme-red" href="javascript:void(0)">R</a>
  <a bind:this={green_theme} class="theme-green" href="javascript:void(0)">G</a>
  <a bind:this={purple_theme} class="theme-purple" href="javascript:void(0)">
    P
  </a>
</div>
<div class="container">
  <Main />
</div>

<Footer />
